import {
  FeatureName,
  SalesChannelName,
  StoreTypeName
} from 'generated/graphql';

import { fields } from 'iron-forge-react-modules';
import * as dataService from './dataService';



export type IStore = dataService.IStore;

export function genComponentAndControllerGenerator({
  salesChannel, types, featuresEnabled
}: {
  featuresEnabled?: FeatureName[];
  salesChannel?: SalesChannelName;
  types?: StoreTypeName[];
} = {}) {
  return fields.ObjectSelectField.genComponentAndControllerGenerator({
    useGetObjects: () => dataService.useQuery({ salesChannel, types, featuresEnabled }),
    fnGetObjectLabel: object => object.displayName
  });
}
